'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactBootstrap = require('react-bootstrap');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarFormOptionsBox = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(CalendarFormOptionsBox, _Component);

  function CalendarFormOptionsBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CalendarFormOptionsBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarFormOptionsBox.__proto__ || (0, _getPrototypeOf2.default)(CalendarFormOptionsBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false,
      open: false,
      tags: _this.props.calendar.categories.filter(function (c) {
        return c.model === 'tag';
      }),
      types: _this.props.calendar.categories.filter(function (c) {
        return c.model === 'type';
      }),
      audiences: _this.props.calendar.audiences
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CalendarFormOptionsBox, [{
    key: 'toggleOpen',
    value: function toggleOpen() {
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: 'handleOnChangeOptions',
    value: function handleOnChangeOptions(ev) {
      var onChangeOptions = this.props.onChangeOptions;

      onChangeOptions((0, _defineProperty3.default)({}, ev.target.name, ev.target.checked));
    }
  }, {
    key: 'handleOnChangeTaxonomy',
    value: function handleOnChangeTaxonomy(ev) {
      var onChangeTaxonomy = this.props.onChangeTaxonomy;

      var idParts = ev.target.id.split('-');
      onChangeTaxonomy(parseInt(idParts[idParts.length - 1], 10), ev.target.checked);
    }
  }, {
    key: 'handleOnChangeSubOptions',
    value: function handleOnChangeSubOptions(ev) {
      var _props = this.props,
          calendarOptions = _props.calendar.options,
          onChangeOptions = _props.onChangeOptions;

      var newOptions = (0, _extends3.default)({}, calendarOptions[ev.target.name]);

      (0, _keys2.default)(newOptions).forEach(function (el) {
        newOptions[el] = false;
      });

      newOptions[ev.target.value] = true;

      onChangeOptions((0, _defineProperty3.default)({}, ev.target.name, newOptions));
    }
  }, {
    key: 'handleOnChangeTypes',
    value: function handleOnChangeTypes(types) {
      var _props2 = this.props,
          calendarOptions = _props2.calendar.options,
          onChangeOptions = _props2.onChangeOptions;

      var typeIds = types.map(function (t) {
        return t.id;
      });

      onChangeOptions({
        categoryIds: (0, _extends3.default)({}, calendarOptions.categoryIds, { types: typeIds })
      });

      this.setState({ types: types });
    }
  }, {
    key: 'handleOnChangeTags',
    value: function handleOnChangeTags(tags) {
      var _props3 = this.props,
          calendarOptions = _props3.calendar.options,
          onChangeOptions = _props3.onChangeOptions;

      var tagIds = tags.map(function (t) {
        return t.id;
      });

      onChangeOptions({
        categoryIds: (0, _extends3.default)({}, calendarOptions.categoryIds, { tags: tagIds })
      });

      this.setState({ tags: tags });
    }
  }, {
    key: 'handleOnChangeAudiences',
    value: function handleOnChangeAudiences(audiences) {
      var onChangeOptions = this.props.onChangeOptions;

      var audienceIds = audiences.map(function (a) {
        return a.id;
      });

      onChangeOptions({ audienceIds: audienceIds });

      this.setState({ audiences: audiences });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          focused = _state.focused,
          open = _state.open,
          tags = _state.tags,
          types = _state.types,
          audiences = _state.audiences;
      var _props4 = this.props,
          calendar = _props4.calendar,
          polyglot = _props4.polyglot,
          taxonomies = _props4.taxonomies,
          superadmin = _props4.superadmin;

      var calendarOptions = (0, _assign2.default)({
        categories: false,
        audiences: true,
        groups: true,
        tags: true,
        organization: true,
        contactInformation: true,
        widget: false,
        multipleVenues: false,
        allowEventDelete: false,
        media: {
          singleMedia: true,
          multipleMedia: false
        },
        categoryIds: {
          types: [],
          tags: []
        },
        audienceIds: []
      }, calendar.options);

      var wrapperClasses = (0, _classnames2.default)({
        active: focused,
        'calendar-form-options-box': true,
        'line-box': true,
        open: open
      });
      var inputClasses = (0, _classnames2.default)({
        inputs: true,
        open: open,
        'text-left': true
      });

      return _react2.default.createElement(
        'div',
        { className: wrapperClasses },
        _react2.default.createElement(
          'label',
          null,
          polyglot.t('calendars.calendarFormOptionsBox.title')
        ),
        _react2.default.createElement(
          _reactBootstrap.Button,
          { bsStyle: 'link', bsSize: 'small', className: 'toggle-button', onClick: this.toggleOpen.bind(this) },
          open ? polyglot.t('calendars.calendarFormOptionsBox.hide') : polyglot.t('calendars.calendarFormOptionsBox.show')
        ),
        _react2.default.createElement(
          'div',
          { className: inputClasses },
          _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { md: 6 },
              (0, _keys2.default)(calendarOptions).map(function (key) {
                if (key === 'categoryIds' || key === 'audienceIds') {
                  return null;
                }

                if ((0, _typeof3.default)(calendarOptions[key]) === 'object') {
                  return _react2.default.createElement(
                    'div',
                    { key: key },
                    _react2.default.createElement(
                      'label',
                      null,
                      polyglot.t('calendars.calendarFormOptionsBox.' + key)
                    ),
                    (0, _keys2.default)(calendarOptions[key]).map(function (subkey) {
                      return _react2.default.createElement(_components.Input, {
                        name: key,
                        onChange: _this2.handleOnChangeSubOptions.bind(_this2),
                        id: subkey,
                        key: 'option-' + subkey,
                        type: 'radio',
                        value: subkey,
                        defaultChecked: calendarOptions[key][subkey],
                        label: polyglot.t('calendars.calendarFormOptionsBox.' + subkey)
                      });
                    })
                  );
                }
                return _react2.default.createElement(_components.Input, {
                  name: key,
                  onChange: _this2.handleOnChangeOptions.bind(_this2),
                  id: key,
                  key: 'option-' + key,
                  type: 'checkbox',
                  defaultChecked: calendarOptions[key],
                  label: polyglot.t('calendars.calendarFormOptionsBox.' + key)
                });
              }),
              superadmin && taxonomies.length > 0 && _react2.default.createElement(
                'div',
                { className: 'taxonomies' },
                _react2.default.createElement(
                  'label',
                  null,
                  polyglot.t('calendars.calendarFormOptionsBox.taxonomies')
                ),
                taxonomies.map(function (taxonomy) {
                  return _react2.default.createElement(_components.Input, {
                    name: taxonomy.slug,
                    onChange: _this2.handleOnChangeTaxonomy.bind(_this2),
                    id: 'taxonomy-' + taxonomy.id,
                    key: 'option-taxonomy-' + taxonomy.id,
                    type: 'checkbox',
                    defaultChecked: calendar.taxonomies.find(function (tax) {
                      return tax.id === taxonomy.id;
                    }),
                    label: taxonomy.name
                  });
                })
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { md: 6 },
              superadmin && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'label',
                  null,
                  polyglot.t('calendars.calendarFormOptionsBox.categories')
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(_components.TypeBox, {
                  popoverContainer: this,
                  selectedTypes: types || [],
                  onChange: this.handleOnChangeTypes.bind(this),
                  polyglot: polyglot,
                  required: false,
                  errors: []
                }),
                _react2.default.createElement(_components.TagBox, {
                  popoverContainer: this,
                  onChange: this.handleOnChangeTags.bind(this),
                  selectedTags: tags || [],
                  polyglot: polyglot,
                  required: false,
                  errors: []
                }),
                _react2.default.createElement(
                  'label',
                  null,
                  polyglot.t('calendars.calendarFormOptionsBox.audiences')
                ),
                _react2.default.createElement(_components.AudienceBox, {
                  popoverContainer: this,
                  selectedAudiences: audiences || [],
                  onChange: this.handleOnChangeAudiences.bind(this),
                  polyglot: polyglot
                })
              )
            )
          )
        )
      );
    }
  }]);
  return CalendarFormOptionsBox;
}(_react.Component), _class.propTypes = {
  calendar: _propTypes2.default.object.isRequired,
  onChangeOptions: _propTypes2.default.func.isRequired,
  onChangeTaxonomy: _propTypes2.default.func.isRequired,
  polyglot: _propTypes2.default.object.isRequired,
  taxonomies: _propTypes2.default.array.isRequired,
  superadmin: _propTypes2.default.bool.isRequired
}, _temp2);
exports.default = CalendarFormOptionsBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Calendar/CalendarFormOptionsBox.js
// module id = 2189
// module chunks = 0